import { render, staticRenderFns } from "./ProductVariantModal.vue?vue&type=template&id=35c63132&scoped=true"
import script from "./ProductVariantModal.vue?vue&type=script&lang=js"
export * from "./ProductVariantModal.vue?vue&type=script&lang=js"
import style0 from "./ProductVariantModal.vue?vue&type=style&index=0&id=35c63132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c63132",
  null
  
)

export default component.exports